.wrapper {
    position: relative;
    width: 100%;
    max-width: 360px;
    font-family: var(--tempest-font-sans);
}

.input {
    width: 100%;
    height: var(--tempest-control-height-md);
    padding: 0 36px 0 36px;
    border: 1px solid var(--tempest-border);
    border-radius: var(--tempest-control-radius);
    background-color: var(--tempest-bg);
    color: var(--tempest-text);
    font-family: inherit;
    font-size: var(--tempest-control-font-md);
    box-shadow: var(--tempest-shadow-xs);
    transition: var(--tempest-transition-color), var(--tempest-transition-shadow);
}

.input::placeholder {
    color: var(--tempest-text-subtle);
}

.input:hover:not(:focus):not(:disabled) {
    border-color: var(--tempest-border-strong);
}

.input:focus {
    outline: none;
    border-color: var(--tempest-primary);
    box-shadow: 0 0 0 var(--tempest-focus-ring-width) var(--tempest-focus-ring-color);
}

.iconLeft,
.clear {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--tempest-text-muted);
}

.iconLeft {
    left: 12px;
    pointer-events: none;
}

.clear {
    right: 8px;
    width: 24px;
    height: 24px;
    border: none;
    background: transparent;
    border-radius: var(--tempest-radius-full);
    transition: var(--tempest-transition-color);
    cursor: pointer;
}

@media (hover: hover) and (pointer: fine) {
    .clear:hover {
        background-color: var(--tempest-surface);
        color: var(--tempest-text);
    }
}

.clear:focus-visible {
    outline: var(--tempest-focus-ring-width) solid var(--tempest-focus-ring-color);
    outline-offset: 2px;
}
